export enum EDisconnectReason {
    DisabledByClient = 1,
    OFDOnly = 2,
    GasStation = 3,
}
